import * as React from 'react';
import { Query } from 'react-apollo';

import type { ApolloError } from 'apollo-client';
import gql from 'graphql-tag';

// diagnosticSessions.v1?action=getPostLevelSetResults&id=42484530~statistics

export const LevelSetsResultsQuery = gql`
  query LevelSetsResultsQuery($userId: String!, $skillId: String!) {
    LevelSetsResultsQuery(input: {}, userId: $userId, skillId: $skillId)
      @rest(
        type: "LevelSetSessionsV1"
        path: "levelSetSessions.v1?action=getPostLevelSetResults&id={args.userId}~{args.skillId}"
        method: "POST"
      ) {
      learnersScorePercentile
      wrongQuestions
      skippedQuestions
      updatedSkillScore
      correctQuestions
      attemptNumber
    }
  }
`;

type LevelSetsResultsQueryVars = {
  skillId: string;
  userId: number;
};

export type PostLevelSetResults = {
  learnersScorePercentile: number;
  wrongQuestions: number;
  correctQuestions: number;
  skippedQuestions: number;
  attemptNumber: number;
  totalAttempts: number;
  updatedSkillScore: number;
};

type Props = {
  skillId: string;
  userId: number;
  children(props: { loading: boolean; error?: ApolloError; data: PostLevelSetResults | null }): JSX.Element;
};

const LevelSetsResultDataProvider = ({ skillId, userId, children }: Props) => {
  return (
    <Query<{ LevelSetsResultsQuery: PostLevelSetResults }, LevelSetsResultsQueryVars>
      query={LevelSetsResultsQuery}
      variables={{
        userId,
        skillId,
      }}
    >
      {({ data, loading, error }) => {
        return children({
          loading,
          error,
          data: {
            learnersScorePercentile: data?.LevelSetsResultsQuery?.learnersScorePercentile ?? 0,
            wrongQuestions: data?.LevelSetsResultsQuery?.wrongQuestions ?? 0,
            correctQuestions: data?.LevelSetsResultsQuery?.correctQuestions ?? 0,
            updatedSkillScore: data?.LevelSetsResultsQuery?.updatedSkillScore ?? 0,
            skippedQuestions: data?.LevelSetsResultsQuery?.skippedQuestions ?? 0,
            attemptNumber: data?.LevelSetsResultsQuery?.attemptNumber ?? 1,
            totalAttempts: data?.LevelSetsResultsQuery?.totalAttempts ?? 2,
          },
        });
      }}
    </Query>
  );
};

export default LevelSetsResultDataProvider;
